import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=1ea21c24&scoped=true"
import script from "./Remark.vue?vue&type=script&lang=js"
export * from "./Remark.vue?vue&type=script&lang=js"
import style0 from "./Remark.vue?vue&type=style&index=0&id=1ea21c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea21c24",
  null
  
)

export default component.exports